'use strict';

var copy = require('shallow-copy');

var refine = function refine(dateRanges, params) {
  var selectedDateRange = params.daterange || '999';

  return {
    dateRange: dateRanges.map(function (dateRange) {
      var newDateRange = copy(dateRange);

      newDateRange.isActive = selectedDateRange === dateRange.value;

      if (!newDateRange.isActive) {
        newDateRange.refineParams = copy(params);
        newDateRange.refineParams.daterange = dateRange.value;
      }

      return newDateRange;
    })
  };
};

module.exports = refine;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/refinements/daterange.js
 ** module id = 498
 ** module chunks = 0
 **/